import { useTranslation } from "react-i18next";
import { usePageMeta } from "@/hooks/usePageMeta";
import styles from "./ContentPage.module.css";

export function Imprint() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("de") ? "de" : "non-de";

  usePageMeta({
    title: t("pageMeta.imprintTitle"),
    description: t("pageMeta.imprintDescription"),
  });

  return (
    <article className={styles.page}>
      <div>
        <h1>{t("imprint.title")}</h1>
        {lang === "non-de" && (
          <p className={styles.disclaimer}>{t("imprint.legalDisclaimer")}</p>
        )}
      </div>

      <section>
        <h2>Anbieter</h2>
        <p>
          brings-mit.com<br />
          Joachim Klingler<br />
          Holunderweg 5<br />
          73479 Ellwangen<br />
          Deutschland
        </p>
      </section>

      <section>
        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:hello@brings-mit.com">hello@brings-mit.com</a>
        </p>
      </section>

      <section>
        <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>Joachim Klingler (Anschrift wie oben)</p>
      </section>

      <section>
        <h2>Haftungsausschluss</h2>
        <p>
          Die Inhalte dieser Seiten werden mit größtmöglicher Sorgfalt erstellt.
          Für die Richtigkeit, Vollständigkeit und Aktualität kann jedoch keine
          Gewähr übernommen werden.
        </p>
        <p>
          Bei Links zu externen Seiten haben wir keinen Einfluss auf deren
          Gestaltung und Inhalte. Deshalb distanzieren wir uns ausdrücklich
          von allen Inhalten dieser verlinkten Seiten und machen uns deren
          Inhalt nicht zu eigen.
        </p>
      </section>
    </article>
  );
}
